import * as React from 'react';
import { Redirect } from 'react-router-dom';

import { RouterError } from '~src/app/spaces/RouterHelpers/RouterError';
import { Favorites } from '~src/content/resources/Favorites';
import { IPublishedConnectionTableDetailInfo } from '~src/ts/models/IPublishedConnectionTableInfo';

import { SpacesSiteUrls } from '../../app/spaces/SpacesSiteUrls';
import { PublishedConnectionTables } from '../resources/PublishedConnectionTables';

export interface PublishedConnectionTableSpaceFavoriteRedirectProps {
  readonly publishedConnectionTableId: string;
  readonly urls: SpacesSiteUrls;
}

type PublishedConnectionTableStatus = 'unfetched' | 'fetched' | 'error';

export const PublishedConnectionTableSpaceFavoriteRedirect: React.FunctionComponent<PublishedConnectionTableSpaceFavoriteRedirectProps> = props => {
  const [ publishedConnectionTableStatus, setPublishedConnectionTableStatus ] = React.useState<PublishedConnectionTableStatus>('unfetched');

  React.useEffect(
    () => {
      let didCancel = false;

      fetchPublishedConnectionTable(props.publishedConnectionTableId)
        .then(() => !didCancel && setPublishedConnectionTableStatus('fetched'))
        .catch(() => {
          removeFavoritePublishedConnectionTable(props.publishedConnectionTableId);
          !didCancel && setPublishedConnectionTableStatus('error');
        });

      return () => didCancel = true;
    },
    [props.publishedConnectionTableId]
  );

  if (publishedConnectionTableStatus === 'unfetched') {
    return null;
  } else if (publishedConnectionTableStatus === 'fetched') {
    return <Redirect to={props.urls.publishedConnectionTablePath(props.publishedConnectionTableId)}/>;
  } else {
    return <RouterError errorType={'publishedConnectionTable-removed-favorite'} urls={props.urls} />;
  }
};

async function fetchPublishedConnectionTable(publishedConnectionTableId: string): Promise<IPublishedConnectionTableDetailInfo> {
  return PublishedConnectionTables.getById(publishedConnectionTableId);
}

function removeFavoritePublishedConnectionTable(publishedConnectionTableId: string) {
  Favorites.remove(publishedConnectionTableId, 'publishedConnectionTable');
}
